import { createContext, useContext, useState, useCallback, useEffect, useRef, useMemo } from 'react'

export const CardMinimizedCtx = createContext({ states: {}, setCard: () => {} })

function loadAll() {
  const map = {}
  try {
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i)
      if (key?.startsWith('card-minimized:')) {
        map[key.replace('card-minimized:', '')] = localStorage.getItem(key) === '1'
      }
    }
  } catch {}
  return map
}

export function CardMinimizedProvider({ children, rowGroups = [], syncRows = true }) {
  const [states, setStates] = useState(loadAll)
  const rowGroupsRef = useRef(rowGroups)
  useEffect(() => { rowGroupsRef.current = rowGroups }, [rowGroups])

  const setCard = useCallback((id, minimized) => {
    const isDesktop = typeof window !== 'undefined' && window.innerWidth >= 1024
    setStates(prev => {
      const next = { ...prev, [id]: minimized }
      try { localStorage.setItem(`card-minimized:${id}`, minimized ? '1' : '0') } catch {}
      // expand or collapse on desktop → sync entire row
      if (isDesktop && syncRows) {
        const row = rowGroupsRef.current.find(r => r.includes(id)) ?? []
        for (const rowId of row) {
          if (rowId !== id) {
            next[rowId] = minimized
            try { localStorage.setItem(`card-minimized:${rowId}`, minimized ? '1' : '0') } catch {}
          }
        }
      }
      return next
    })
  }, [syncRows])

  const api = useMemo(() => ({ states, setCard }), [states, setCard])
  return <CardMinimizedCtx.Provider value={api}>{children}</CardMinimizedCtx.Provider>
}
